export default {
  validate(files, value) {
    let success = true;
    let sumSize = 0;
    const size = Number(value[0]) * 1024 * 1024;

    files.forEach(file => {
      sumSize += file.size;
    });

    const fileSize = sumSize;
    if (fileSize > size) {
      success = false;
    }

    return success;
  },
};
